<template>
  <div>
    <span>当前位置：</span>
    <router-link tag="a" :to="{path:'/'}">首页</router-link>
    <span v-for="(nav,index) in navList" :key="index">
      <template v-if="$route.query.fId == nav.catid">
        <span>></span>
        <a href="javascript:;" @click="navClick(nav.catid, nav.catname)">{{nav.catname}}</a>
      </template>
      <span v-for="(subnav,i) in nav.level2" :key="i">
        <template v-if="$route.query.id == subnav.catid">
          <span>></span>
          <a
            href="javascript:;"
            @click="subnavClick(nav.catid, nav.catname, subnav.catid, subnav.catname)"
          >{{subnav.catname}}</a>
        </template>
      </span>
    </span>
  </div>
</template>
<script>
var that;

export default {
  data() {
    return {
      navList: []
    };
  },
  mounted() {
    that = this;
    that.init();
    console.log("----");
    console.log(this.$route.query);
  },
  methods: {
    init() {
      $.ajax({
        type: "get",
        url: url + "/category",
        success: function(data) {
          if (data.code == "0") {
            that.navList = data.data;
          }
        },
        error(data) {
          alert(data.msg);
        }
      });
    },
    // 一级导航跳转事件
    navClick(id, name) {
      console.log("1111111");
      if (id == 9 || id == 12 || id == 61) {
        //学科奥赛、教育发展基金会、国际教育
        that.$router.push({
          path: "leftNavList",
          query: {
            fId: id,
            id: id,
            name: name
          }
        });
        this.$emit("articleList");
      } else {
        this.$emit("articleList");
        that.$router.push({
          path: "list",
          query: {
            fId: id,
            id: id,
            name: name
          }
        });
      }
    },
    // 二级导航跳转事件
    subnavClick(fId, fName, id, secondName) {
      if (id == 14) {
        //学校概况
        that.$router.push({
          path: "list",
          query: {
            fId: fId,
            name: fName,
            id: id,
            secondName: secondName
          }
        });
      } else {
        that.$router.push({
          path: "leftNavList",
          query: {
            fId: fId,
            name: fName,
            id: id,
            secondName: secondName
          }
        });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/com/nowPosition.vue